import React, { Suspense } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { COOKIE, getCookie } from '../services/Cookie';
import { fronturls } from '../constants/FrontendUrls';

// Utility function to get the user type from your authentication context or state
const getUserRole = () => {
	let user = {
		userId:getCookie(COOKIE.UserId),
		token:getCookie(COOKIE.Token),
		userType:getCookie(COOKIE.UserType),
	}
	return user;
};
// Component to protect admin routes
export const AdminRoute = ({ children }) => {
	const userRole = getUserRole();
	const location = useLocation();
	if(userRole?.userId&&userRole?.token){
		if (userRole?.userType === '0'){
			// Redirect to home page or any other page if the user is not an admin
			return <Navigate to={fronturls.StudentDashboard} state={{ from: location }} replace />;
		}
	}else{
		return <Navigate to={fronturls.StudentLogin} state={{ from: location }} replace />;
	}
	return <Suspense>{children}</Suspense>;
};
// Component to protect routes for students (e.g., prevent access to admin routes)
export const StudentRoute = ({ children }) => {
	const userRole = getUserRole();
	const location = useLocation();
	if(userRole?.userId&&userRole?.token){
		if (userRole?.userType !== '0'){
			// Redirect to a staff dashboard page or show an error message if a student is trying to access admin routes
			return <Navigate to={fronturls.AdminDashboard} state={{ from: location }} replace />;
		}
	}else{
		return <Navigate to={fronturls.StudentLogin} state={{ from: location }} replace />;
	}
	return <Suspense>{children}</Suspense>;
};
export const CommonRoute = ({ children }) => {
	const userRole = getUserRole();
	const location = useLocation();
	if(!userRole?.userId && !userRole?.token){
		return <Navigate to={fronturls.StudentLogin} state={{ from: location }} replace />;
	}
	return <Suspense>{children}</Suspense>;
};
// Component to protect routes for types of admin users based on user type
export const RoleProtectedRoute = ({allowedRoles, children }) => {
	const userRole = getUserRole();
	if (allowedRoles.includes(userRole?.userType)){
		return children ? <Suspense>{children}</Suspense> : <Outlet/>;
	} else {
		return <Navigate to="/page-not-found" state={{ fromLocation:"fromRoutes" }} />;
	}
};
